// @flow
import type { State } from '../types';

const subStateSelector = (state: State) => state.config;

export const statusSelector = (state: State) => {
    const subState = subStateSelector(state);
    return subState.status;
};

export const configSelector = (state: State) => {
    const subState = subStateSelector(state);
    return subState.data;
};

export const configFetchedSelector = (state: State) => {
    const status = statusSelector(state);
    return status && status.fetched;
};

export const generalConfigSelector = (state: State) => {
    const config = configSelector(state);
    return config.general;
};

export const statusConfigSelector = (state: State) => {
    const config = configSelector(state);
    return config.status;
};

export const runwaysSelector = (state: State) => {
    const config = configSelector(state);
    return config.runways;
};

export const sessionConfigSelector = (state: State) => {
    const config = configSelector(state);

    return config.session;
};

export const zonesConfigSelector = (state: State) => {
    const config = configSelector(state);

    return config.zones;
};

export const mapConfigSelector = (state: State) => {
    const config = configSelector(state);

    return config.map;
};

export const activeMapSourceSelector = (state: State) => {
    const mapConfig = mapConfigSelector(state);
    const status = statusSelector(state);

    if(!status.fetched) {
        return undefined;
    }

    const sourceId = mapConfig && mapConfig.previewSource || mapConfig.activeSource;
    return sourceId && mapConfig.sources[sourceId];
};

export const debugConfigSelector = (state: State) => {
    const config = configSelector(state);

    return config.debug || {};
};